import React, { useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import Avatar from "@material-ui/core/Avatar";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import AssignmentIcon from "@material-ui/icons/Assignment";
import Paper from "@material-ui/core/Paper";
import Modal from "@material-ui/core/Modal";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import store from "../../../reduxstore";
import SERVER_ADDRESS from "../../../config";
import PasswordChangeForm from "./PasswordChangeForm";
const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 2
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20
  },
  button: {
    margin: theme.spacing(1)
  },
  appbar: {
    marginBottom: 1
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  },
  avatar: {
    margin: theme.spacing(),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing()
  },
  submit: {
    marginTop: theme.spacing(3)
  },
  modal: {
    width: "350px",
    margin: "200px auto"
  }
}));

//登录表单组件
function UserProfileForm(props) {
  const classes = useStyles();
  const { handleSubmit, formTitle, canSubmit } = props;
  const { account } = store.getState();
  //refs
  const validateRefs = {
    nickname: React.createRef(),
    email: React.createRef(),
    card_number: React.createRef()
  };

  const initState = {
    nickname: account.nickname,
    email: account.email,
    card_number: account.card_number
  };
  const [formValue, setFromValue] = useState(initState);

  const handleChange = name => event => {
    setFromValue({ ...formValue, [name]: event.target.value });
  };
  const handleBlur = refname => {
    return event => {
      validateRefs[refname].current.validate(event.target.value);
    };
  };
  return (
    <Paper className={classes.paper}>
      <Avatar className={classes.avatar}>
        <AssignmentIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        {formTitle}
      </Typography>
      <PasswordChangeForm />
      <ValidatorForm
        className={classes.form}
        onSubmit={handleSubmit(
          `${SERVER_ADDRESS}/api/users/${account.id}/`,
          formValue,
          "PATCH"
        )}
        instantValidate={true}
        noValidate
      >
        <TextValidator
          ref={validateRefs.nickname}
          autoFocus
          required
          fullWidth
          label="昵称"
          onBlur={handleBlur("nickname")}
          onChange={handleChange("nickname")}
          name="nickname"
          value={formValue.nickname}
          validators={["required"]}
          errorMessages={["昵称不能为空"]}
        />
        <TextValidator
          ref={validateRefs.email}
          fullWidth
          label="邮箱"
          onBlur={handleBlur("email")}
          onChange={handleChange("email")}
          name="email"
          value={formValue.email}
          validators={["isEmail"]}
          errorMessages={["邮箱格式不正确"]}
        />

        <TextValidator
          ref={validateRefs.card_number}
          fullWidth
          label="卡号"
          onBlur={handleBlur("card_number")}
          onChange={handleChange("card_number")}
          name="card_number"
          value={formValue.card_number}
          validators={[]}
          errorMessages={[]}
        />
        <br />
        <Button
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          type="submit"
          disabled={!canSubmit}
        >
          {canSubmit ? "更新个人信息" : "发送中···"}
        </Button>
      </ValidatorForm>
    </Paper>
  );
}

//登录弹出Modal组件，需要其他情况下复用
function UserPofileModal(props) {
  const classes = useStyles();
  const [canSubmit, setCansubmit] = useState(true);

  const { open, handleClose, formTitle } = props;

  //发送登录数据
  const handleSubmit = (postUrl, formValue, method) => {
    return e => {
      e.preventDefault();
      setCansubmit(false);
      let h = new Headers();
      h.append("Accept", "application/*");
      let formdata = new FormData();
      Object.keys(formValue).forEach(value => {
        formdata.append(value, formValue[value]);
        console.log(value, formValue[value]);
      });

      let req = new Request(postUrl, {
        method: method,
        headers: {
          Accept: "application/json, text/plain, */*"
        },
        mode: "cors",
        credentials: "include",
        body: formdata
      });

      fetch(req)
        .then(res => {
          if (!res.ok) {
            throw Error(res.statusText);
          }
          return res.json();
        })
        .then(data => {
          console.log(data);
          //关闭
          handleClose();
          //提交成功后的反馈SnackBar
          setCansubmit(true);

          props.enqueueSnackbar("修改个人信息成功", {
            variant: "success"
          });
          //更新redux存储的个人信息
          store.dispatch({ type: "UPDATEAccount", account: data });
        })
        .catch(error => {
          //失败后显示错误SnackBar
          // console.log(error);
          setCansubmit(true);

          props.enqueueSnackbar("修改个人信息失败", {
            variant: "error"
          });
        });
    };
  };
  return (
    <Modal open={open} onClose={handleClose} className={classes.modal}>
      <UserProfileForm
        handleSubmit={handleSubmit}
        formTitle={formTitle}
        canSubmit={canSubmit}
      />
    </Modal>
  );
}

export default withSnackbar(UserPofileModal);
